import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import Navbar from "./Navbar";
import Footer from "./Footer";
import './LegalApp.css';

const FIRComplaint = ({ API_URL }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { data } = location.state || { data: {} };
    const [firText, setFirText] = useState(data.firText || "");
    const fromPage = location.state?.fromPage || "Case List";

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState("");

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setMessage("");

        data.firText = firText;
        var jwt = localStorage.getItem('jwtToken');

        try {
            const response = await axios.put(API_URL + `/fir`, data, {
                headers: {
                    'Content-Type': 'application/json', // Set the content type to JSON
                    'Authorization': `Bearer ${jwt}`,
                },
            });

            if (response.status === 200) {
                setMessage("FIR updated successfully!");
            } else {
                setMessage("Failed to update FIR. Please try again.");
            }
        } catch (error) {
            console.error("Error updating FIR:", error);
            setMessage("Failed to update FIR. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const analyseFIR = async () => {
        setIsSubmitting(true);
        setMessage("");

        var jwt = localStorage.getItem('jwtToken');

        try {
            //Update fir if the text is updated
            if (firText !== data.firText) {
                data.firText = firText;
                const response = await axios.put(API_URL + `/fir`, data, {
                    headers: {
                        'Content-Type': 'application/json', // Set the content type to JSON
                        'Authorization': `Bearer ${jwt}`,
                    },
                });

                if (response.status !== 200) {
                    setMessage("Error processing request. Please try again.");
                    return;
                }
            }

            const response = await axios.get(API_URL + `/fir/summarize/` + data.id, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwt}`,
                },
            });

            if (response.status === 200) {
                navigate('/fir', { state: { API_URL: API_URL, data: response.data } });
            } else {
                setMessage("Error processing request. Please try again.");
            }
        } catch (error) {
            setMessage("Error processing request. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Navbar />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
                minHeight: '80vh',
            }}>
                <div style={{
                    maxWidth: '800px',
                    width: '100%',
                    textAlign: 'center',
                }}>
                    {data.allegations && (
                        <h2>FIR Text</h2>
                    )}
                    {!data.allegations && (
                        <div>
                            <h2>Verify FIR Text</h2>
                            <p style={{ fontSize: '16px', color: '#555', marginTop: '-10px' }}>
                                (Review FIR text and correct any errors or add any missing details before proceeding to analysis.)
                            </p>
                        </div>
                    )}
                    <textarea
                        value={firText}
                        onChange={(e) => setFirText(e.target.value)}
                        style={{
                            width: '100%',
                            height: '300px',
                            marginTop: '20px',
                            padding: '10px',
                            fontSize: '16px',
                            lineHeight: '1.5',
                            resize: 'vertical',
                        }}
                    />
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                    }}>
                        {/* {fromPage === "Case List" && ( */}
                        <button
                            onClick={() => navigate("/mycases")}
                            style={{
                                fontSize: "18px",
                                color: '#094268',
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontWeight: "bold",
                                padding: '20px 20px',
                                visibility: fromPage === "Case List" ? "visible" : "hidden"
                            }}
                        >
                            <span style={{ fontSize: "20px" }}>←</span> My Cases
                        </button>

                        {/* )} */}

                        {fromPage === "Case List" ? (
                            <button
                                className="submit-button"
                                onClick={handleSubmit}
                                disabled={isSubmitting}
                                hidden={data.allegations}
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                }}
                            >
                                {isSubmitting ? <div className="spinner"></div> : 'Update FIR'}
                            </button>
                        ) : (
                            <button
                                className="submit-button"
                                onClick={analyseFIR}
                                disabled={isSubmitting}
                                hidden={data.allegations}
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    fontSize: '16px',
                                    cursor: 'pointer',
                                }}
                            >
                                {isSubmitting ? <div className="spinner"></div> : 'Analyse FIR'}
                            </button>
                        )}
                    </div>

                    {message && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                {/* <h2>Error</h2> */}
                                <div className="error-message" style={{ marginBottom: '15px', fontSize: '16px', color: '#333' }}>
                                    <strong>{message}</strong>
                                </div>
                                <button
                                    className="error-ok-button"
                                    onClick={() => setMessage(null)}
                                    style={{ padding: '10px 20px', fontSize: '14px', color: 'white', backgroundColor: '#007bff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default FIRComplaint;
